module.exports = __webpack_public_path__ + "static/media/icon-video-settings.c6bee9cf.png";